const FEATURES = [
  {
    icon: 'ri-4k-line',
    title: '高清画质 · 流畅不卡顿',
    desc: '全站资源支持1080P至4K超清画质，智能CDN加速引擎确保播放流畅零缓冲，为您带来影院级观影享受。',
    color: 'text-primary-500',
    bg: 'bg-primary-100/80',
  },
  {
    icon: 'ri-stack-line',
    title: '海量片库 · 全类型覆盖',
    desc: '汇聚10万+影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等多类型，每日实时更新最新片源，追剧永不断档。',
    color: 'text-accent-500',
    bg: 'bg-accent-100/80',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配 · 随时随地看',
    desc: '完美适配电脑、平板、手机等多终端设备，智能界面自适应，无论在家还是出行途中都能畅快追剧。',
    color: 'text-secondary-700',
    bg: 'bg-secondary-100/80',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">为什么选择番茄影视</h2>
          <p className="text-sm text-foreground-500 mt-2">三大核心优势，打造极致观影体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FEATURES.map((f) => (
            <div key={f.title} className="bg-background-50 rounded-2xl p-6 md:p-8 text-center group hover:bg-background-100 transition-colors cursor-pointer">
              <div className={`w-16 h-16 mx-auto rounded-2xl ${f.bg} flex items-center justify-center mb-5`}>
                <i className={`${f.icon} ${f.color} text-2xl`} />
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-3 font-heading">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}